var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "23px",
    viewBox: "0 0 27 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "timing",
    fillRule: "nonzero",
    fill: "#061B2D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 5.000000)",
    id: "Group-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,11.0086207 L3,11.0086207 L6.62068966,3.5 L10.5,11.0086207 Z M5.95125035,1.59041316 L0.985733106,11.4204624 C0.733746058,11.9193118 1.09629125,12.5086207 1.65517241,12.5086207 L11.5862069,12.5086207 C12.1450881,12.5086207 12.5076333,11.9193118 12.2556462,11.4204624 L7.29012896,1.59041316 C7.01274721,1.04129085 6.2286321,1.04129085 5.95125035,1.59041316 Z",
    id: "Triangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2.37068966 C24.4142136,2.37068966 24.75,2.03490322 24.75,1.62068966 C24.75,1.20647609 24.4142136,0.870689655 24,0.870689655 L14.0689655,0.870689655 C13.654752,0.870689655 13.3189655,1.20647609 13.3189655,1.62068966 C13.3189655,2.03490322 13.654752,2.37068966 14.0689655,2.37068966 L24,2.37068966 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7844828,1.82758621 C19.7844828,1.41337264 19.4486963,1.07758621 19.0344828,1.07758621 C18.6202692,1.07758621 18.2844828,1.41337264 18.2844828,1.82758621 L18.2844828,11.7586207 C18.2844828,12.1728343 18.6202692,12.5086207 19.0344828,12.5086207 C19.4486963,12.5086207 19.7844828,12.1728343 19.7844828,11.7586207 L19.7844828,1.82758621 Z",
    id: "Line"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiming);
export default __webpack_public_path__ + "static/media/timing.fd1f8142941ca7464287ef2cb9203d7f.svg";
export { ForwardRef as ReactComponent };